import React, {useEffect, useState} from 'react';
import {Spin} from "antd";
import styled from "styled-components";

const SpinNewDiv = styled.div`
  top:50%;
  left: 50%;
  position: fixed;//earlier absolute, fixed will put middle of the page;
  display: none;
  z-index: 1000000;
  text-align: center;
`;

function SpinnerNew({display})
{
    const [style, setStyle] = useState(display ? {display:'block'} : {display: 'none'});

    useEffect(() => {
        setStyle(display ? {display:'block'} : {display: 'none'});
    }, [display]);

    return (

        <SpinNewDiv style={style}>
              <Spin size="large" />
        </SpinNewDiv>
    )
}

export default SpinnerNew;

